export default "__VITE_ASSET__BSVenQyI__"